import React from 'react';
import PropTypes from 'prop-types';

// import Rating from '@material-ui/lab/Rating';

const propTypes = {
    value: PropTypes.number,
    className: PropTypes.string,
};

const RatingCell = ({ className }) => {
    return (
        <td className={className}>
            <div>RATING</div>
            {/* <Rating name="read-only" value={value} readOnly /> */}
        </td>
    );
};

RatingCell.propTypes = propTypes;

export default RatingCell;